// client/src/coms/views/GamesView.js
// The Activities destination inside the Voxemera shell (internally still the "games" tab), opened from the
// button beside Settings in the user bar. It stays mounted while the player is in an activity, so switching
// to Comms, Canvas or anything else does not end a game or stop Watch Together playback.
import React from 'react';
import GamesHub from './games_parts/GamesHub';

export default function GamesView({ user, server, visible = true, pendingCode = '', onPendingCodeHandled, onOpenTab, servers, voiceSession, voiceRoom, onJoinVoice }) {
  return (
    <div style={{ height: '100%', width: '100%', flex: '1 1 auto', minWidth: 0, minHeight: 0, display: 'flex' }}>
      <GamesHub
        user={user}
        server={server}
        visible={visible}
        pendingCode={pendingCode}
        onPendingCodeHandled={onPendingCodeHandled}
        onOpenTab={onOpenTab}
        servers={servers}
        voiceSession={voiceSession}
        voiceRoom={voiceRoom}
        onJoinVoice={onJoinVoice}
      />
    </div>
  );
}
